import { render, staticRenderFns } from "./ClientsBase.vue?vue&type=template&id=4a41a7bc&"
import script from "./ClientsBase.vue?vue&type=script&lang=js&"
export * from "./ClientsBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports